import { currencyText } from '@/common/app/currency'
import { OrderHistory } from '@/common/model/master/orderHistory'

import Badge, { BadgeType } from '@/components/view/atoms/badge/Badge'
import TableRow from '@/components/view/atoms/table/TableRow'
import TableRowItem from '@/components/view/atoms/table/TableRowItem'
import Text, { TextColor } from '@/components/view/atoms/text/Text'

import PurchaserText from './PurchaserText'
import { orderDatetimeText } from './orderDatetimeText'

export interface GroupedOrder {
  order_number: string
  order_datetime: string | null
  customer_id: string | null
  visitor_id: string | null
  source: string
  order_total_price: number | null
  items: OrderHistory[]
  subtotal: number
}

interface Props {
  group: GroupedOrder
}

const OrderHistoryByOrderListRow = ({ group }: Props) => (
  <TableRow>
    <TableRowItem>
      <Text size={12} nowrap>
        {orderDatetimeText(group.order_datetime)}
      </Text>
    </TableRowItem>
    <TableRowItem width={160}>
      <PurchaserText customerId={group.customer_id} visitorId={group.visitor_id} />
    </TableRowItem>
    <TableRowItem>
      <Text>{group.order_number}</Text>
    </TableRowItem>
    <TableRowItem>
      <div className='flex flex-wrap gap-1'>
        <Text>{group.items.map((i) => i.item_id).join(', ')}</Text>
        <Text size={12} color={TextColor.SECONDARY}>
          （{group.items.length}明細）
        </Text>
      </div>
    </TableRowItem>
    <TableRowItem>
      <Text nowrap>{currencyText(group.subtotal)}</Text>
    </TableRowItem>
    <TableRowItem>
      <Text nowrap>
        {group.order_total_price != null ? currencyText(group.order_total_price) : '-'}
      </Text>
    </TableRowItem>
    <TableRowItem>
      <Badge
        badgeType={group.source === 'tag' ? BadgeType.SQUARE_TERTIARY : BadgeType.SQUARE_SECONDARY}
      >
        {group.source === 'tag' ? 'タグ' : 'CSV'}
      </Badge>
    </TableRowItem>
  </TableRow>
)

export default OrderHistoryByOrderListRow
